import type { Consultation } from "@/types/api/consultation";
import type { MouthType, Sector } from "@/types/api/treatment";
import { getToothBrushHairType, getToothBrushType } from "@/utils/patient";
import { capitalizeFirst } from "@/utils/string";

export const sectorOptions: Array<{
  value: Sector;
  label: string;
}> = [
  { value: "ONE", label: "Secteur 1" },
  { value: "TWO", label: "Secteur 2" },
  { value: "THREE", label: "Secteur 3" },
  { value: "FOUR", label: "Secteur 4" },
];

export const getSectorLabel = (sector: Sector) => {
  return sectorOptions.find((item) => item.value === sector)?.label ?? "";
};

export const mouthTypeOptions: Array<{
  value: MouthType;
  label: string;
}> = [
  { value: "FULL", label: "Bouche pleine" },
  { value: "SPLIT", label: "Bouche scindée" },
];

export const getMouthPartLabel = (mouthPart: MouthType) => {
  return mouthTypeOptions.find((item) => item.value === mouthPart)?.label ?? "";
};

export const getConsultationFields = (
  consultation: Consultation
): Array<{
  hidden: boolean;
  fields: Array<{ label: string; value: string }>;
}> => {
  const {
    toothbrushBrand,
    toothbrushHairTypes,
    toothbrushTypes,
    sectors,
    mouthParts,
    brushesBrand,
    brushesDimensions,
  } = consultation;

  switch (consultation.consultationStep) {
    case "DEBRIDEMENT":
      return [
        {
          hidden:
            (!mouthParts || mouthParts.length <= 0) &&
            (!sectors || sectors.length <= 0),
          fields: [
            {
              label: "Secteurs",
              value: sectors.map((sector) => getSectorLabel(sector)).join(", "),
            },
            {
              label: "Bouche",
              value: mouthParts
                .map((mouthPart) => getMouthPartLabel(mouthPart))
                .join(", "),
            },
          ],
        },
      ];
    default:
      return [
        {
          hidden:
            !toothbrushBrand &&
            (!toothbrushHairTypes || toothbrushHairTypes.length <= 0) &&
            (!toothbrushTypes || toothbrushTypes.length <= 0),
          fields: [
            {
              label: "Types de brosse à dents",
              value: toothbrushTypes
                .map((toothbrushType) => getToothBrushType(toothbrushType))
                .join(", "),
            },
            {
              label: "Poils des brosses à dents",
              value: toothbrushHairTypes
                .map((toothbrushHairType) =>
                  capitalizeFirst(getToothBrushHairType(toothbrushHairType))
                )
                .join(", "),
            },
            {
              label: "Marque de brosse à dents",
              value: toothbrushBrand ?? "",
            },
          ],
        },
        {
          hidden: !brushesBrand && !brushesDimensions,
          fields: [
            {
              label: "Dimensions des brossettes interdentaires",
              value: brushesDimensions ?? "",
            },
            {
              label: "Marque des brossettes interdentaires",
              value: brushesBrand ?? "",
            },
          ],
        },
      ];
  }
};
